import { Column as a } from "./atoms-v212.js";
import i from "styled-components";
import { Text as n } from "./atoms-v243.js";
import { Button as e } from "./atoms-v26.js";
import { breakpoints as r } from "./atoms-v2125.js";
import { Picture as p } from "./atoms-v233.js";
const c = i.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 24px;
  width: 100%;

  @media ${r.medium} {
    gap: 40px;
    padding-bottom: 32px;
  }

  @media ${r.large} {
    gap: 30px;
  }
`, f = i(a)`
  display: flex;
  gap: 8px;
  position: relative;

  @media ${r.large} {
    gap: 0;
  }

  @media ${r.xLarge} {
    gap: 18px;
  }
`, $ = i.div`
  background-color: ${({ $colorTheme: o = "light", theme: t }) => t == null ? void 0 : t.get(`tokens.surface.${o}.background`)};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px;
  cursor: pointer;
  display: none;
  flex-direction: column;
  padding: 10px ${({ $side: o }) => o === "previous" ? "20px 10px 48px" : "48px 10px 20px"};
  position: absolute;
  ${({ $side: o }) => o === "previous" ? "left: 56px;" : "right: 56px;"}

  @media ${r.large} {
    display: flex;
    top: 50%;
    transform: translateY(-50%);
  }

  ${({ $variant: o }) => {
  if (o === "oneRoom")
    return `
    @media ${r.medium} {
      display: flex;
      left: 50%; 
      top: 50%;
      transform: translate(-50%, -50%);
      width: fit-content;
    }
    `;
}}
`, m = i(n)`
  ${({ $side: o }) => o === "previous" ? "text-align: right;" : o === "imageBottom" ? "text-align: center;" : "text-align: left;"}

  @media ${r.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};
  }

  @media ${r.xLarge} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.expressive").toJS()};
  }
`, b = i(e)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  ${({ $side: o }) => o === "previous" ? "left: -22px;" : "right: -22px;"}
`, v = i(n)`
  ${({ $side: o }) => o === "previous" ? "text-align: right;" : o === "imageBottom" ? "text-align: center;" : "text-align: left;"}

  @media ${r.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.01").toJS()};
  }

  @media ${r.xLarge} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.02").toJS()};
  }
`, k = i.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`, y = i.div`
  cursor: pointer;
`, S = i.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media ${r.large} {
    display: none;
  }
`, L = i(p)`
  cursor: pointer;
  overflow: hidden;

  > img {
    border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusSm")}px;
  }

  ${({ $variant: o }) => {
  if (o === "oneRoom")
    return `
        width: 100%;
        height: auto;
      `;
}}

  @media (prefers-reduced-motion: no-preference) {
    & img {
      transition-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.01")};
      transition-property: transform;
      transition-timing-function: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};

      &:hover {
        transform: scale(1.1);
        transition-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.02")};
      }
    }
  }
`;
export {
  f as ImageColumn,
  S as ImageLabel,
  k as ImageWrapper,
  $ as Label,
  b as LabelButton,
  v as LabelText,
  y as OneImageWrapper,
  m as Price,
  L as RoundedImage,
  c as Wrapper
};
